import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import isString from 'lodash/isString';
import isInteger from 'lodash/isInteger';
import isNumber from 'lodash/isNumber';
import isEmpty from 'lodash/isEmpty';

var validate = function validate() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var validated = content ? Object.keys(content).reduce(function (values, name) {
    var value = content[name] || null;
    // Find the reference
    if (definition && definition.properties) {
      var property = definition.properties.find(function (prop) {
        return prop.name === name;
      }) || null;
      if (property !== null) {
        var isValid = true;
        switch (property.type) {
          case 'string':
            isValid = isString(value);
            break;
          case 'integer':
            isValid = isInteger(value);
            break;
          case 'float':
            isValid = isNumber(value);
            break;
          default:
            isValid = value !== null;
            break;
        }
        // Skip the whole thing it cause it aint gonna work
        if (!isValid && property.required) {
          console.log('VALIDATION ERROR: SKIPPED BECAUSE REQUIRED', content, name); // eslint-disable-line
          return null;
        }
        if (values !== null && isValid) {
          return _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value));
        }
        console.log('VALIDATION ERROR: VALID TYPE', name, content); // eslint-disable-line
      }
    }

    return values;
  }, {}) : {};
  return !isEmpty(validated) ? validated : null;
};

var stripTags = function stripTags(str) {
  if (!str) {
    return null;
  }
  return str.replace(/(<([^>]+)>)/gi, '');
};

export { stripTags, validate };
